import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-nav-bar-v2",
  templateUrl: "./nav-bar-v2.component.html",
  styleUrls: ["./nav-bar-v2.component.scss"],
})
export class NavBarV2Component implements OnInit {
  @Input() darkNav: boolean = false;

  constructor() {}

  ngOnInit(): void {
    window.addEventListener("load", async () => {
      let video = document.querySelector("video[muted][autoplay]");
      // @ts-ignore
      video?.muted = true;

      // @ts-ignore
      video?.play();
    });
  }

  isOpen = false;

  keepOpen: options = {
    solutions: false,
    resources: false,
    company: false,
  };

  solutionItems = [
    {
      title: "Marihub Marketplace",
      link: "/Marihub-Marketplace",
    },
  ];

  resourceItems = [
    {
      title: "Case Studies",
      link: "/Case-Studies",
    },
    {
      title: "Reports",
      link: "/Reports",
    },

    {
      title: "Articles",
      link: "/Articles",
    },
  ];

  companyItems = [
    {
      title: "About Us",
      link: "/About-Us",
    },
    {
      title: "Leadership",
      link: "/Leadership",
    },
    {
      title: "News",
      link: "/News",
    },
  ];

  closeMenu(item: any, type: string) {
    this.keepOpen[type] = false;
    setTimeout(() => {
      if (!this.keepOpen[type]) item.closeMenu();
    }, 200);
  }

  openMenu(item: any, type: string) {
    this.keepOpen[type] = true;
    item.openMenu();
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) document.body.classList.add("body-no-scroll");
    else document.body.classList.remove("body-no-scroll");
  }
}

type options = {
  [key: string]: boolean;
};
